import * as React from "react";
import { FormGroup } from "../Workflows/RightAside/RightAsideHelpers";
import { InlineInvitation } from "./types";
import Input from "@/components/Input";
import Select from "@/components/Select";
import { FormValidator } from "@velaro/velaro-component-lib";
import HtmlSkinEditor from "./HtmlSkinEditor";

interface Props {
  onUpdate(invitation: InlineInvitation): void;
  invitation: InlineInvitation;
  errors: Record<string, string>;
}

export default function InlineInvitationEditor({
  invitation,
  errors,
  onUpdate
}: Props) {
  const contentType = invitation.contentType ?? "inline-chat";

  return (
    <>
      <FormGroup label="Content Type" tooltipText="Inline Chat embeds the chat input directly; Custom HTML lets you design a fully custom skin">
        <Select
          options={[
            { label: "Inline Chat", value: "inline-chat" },
            { label: "Custom HTML", value: "custom-html" }
          ]}
          value={contentType}
          onChange={(value) =>
            onUpdate({ ...invitation, contentType: value as "inline-chat" | "custom-html" })
          }
        />
      </FormGroup>

      {contentType === "inline-chat" && (
        <>
          <FormGroup label="Placeholder Text" tooltipText="Text shown in the chat input before the visitor types">
            <FormValidator error={errors["placeholderText"]}>
              <Input
                value={invitation.placeholderText ?? "Send a message..."}
                onChange={(value) =>
                  onUpdate({ ...invitation, placeholderText: value })
                }
              />
            </FormValidator>
          </FormGroup>
          <FormGroup label="CTA Button Label" tooltipText="Optional button below the chat input. Leave empty to hide.">
            <Input
              value={invitation.ctaLabel ?? ""}
              onChange={(value) => onUpdate({ ...invitation, ctaLabel: value })}
            />
          </FormGroup>
        </>
      )}

      {contentType === "custom-html" && (
        <HtmlSkinEditor
          htmlContent={invitation.htmlContent ?? ""}
          cssContent={invitation.cssContent ?? ""}
          onHtmlChange={(htmlContent) => onUpdate({ ...invitation, htmlContent })}
          onCssChange={(cssContent) => onUpdate({ ...invitation, cssContent })}
        />
      )}
    </>
  );
}
